<template>
  <aside class="col-12 col-xl-3 d-xl-block fullscreen collapse searchfilter float-left" id="searchfilter">
    <div id="searchfilter-wrapper">
      <p class="text-right d-xl-none mt-3">
        <button class="btn btn-link searchfilter-toggle collapsed" data-toggle="collapse" data-target="#searchfilter" aria-expanded="false">
          <span class="icon icon-navigation_pfeil_schliessen_gross" aria-hidden="true"></span><span class="sr-only">Suchfilter ausblenden</span>
        </button>
      </p>
    <div class="d-flex align-items-center justify-content-between">
        <h2 class="mb-0">{{ t('vab.filter.title') }}</h2>
        <button class="btn btn-link btn-reset px-0" role="button" @click="resetFilters">{{ t('vab.filter.reset') }}</button>
      </div>

      <div class="filter-box" v-if="showTypeFilter">
        <span class="filter-box-headline">{{ t('vab.filter.system') }}</span>

        <ul class="list-unstyled mb-0">
          <li class="mb-0" v-for="[key, value] in systemMap" :key="key">
            <div class="d-flex align-items-center">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" v-model="type" :value="value.id" :id="`filter-system-${value.id}`" @change="onSubmit">
                <label class="form-check-label" :for="`filter-system-${value.id}`">
                  {{value.label}}
                </label>
              </div>
              <div class="filter-box-count-number ml-auto">
                {{getSystemCount(value)}}
              </div>
            </div>
          </li>
        </ul>

      </div> <!-- /filter-box -->

      <div class="filter-box" v-if="showDaterangeFilter">
        <span class="filter-box-headline">{{ t('vab.filter.daterange') }}</span>

        <div class="form-group">
            <label for="filter-daterange-from">{{ t('vab.filter.daterangefrom') }}</label>
            <div class="input-group" id="filter-daterange-from-datepicker">
                <input type="date" class="form-control" id="filter-daterange-from" placeholder="TT.MM.JJJJ" v-model="dateFrom" @change="onSubmit">
            </div>
            <label for="filter-daterange-to">{{ t('vab.filter.daterangeto') }}</label>
            <div class="input-group" id="filter-daterange-to-datepicker">
                <input type="date" class="form-control" id="filter-daterange-to" placeholder="TT.MM.JJJJ" v-model="dateTo" @change="onSubmit">
            </div>
        </div>

      </div> <!-- /filter-box -->

      <div class="filter-box" v-if="showDepFilter">
        <span class="filter-box-headline">{{ t('vab.filter.dep') }}</span>

        <ul class="list-unstyled mb-0">
          <li class="mb-0" v-for="([key, value], index) in depMap" :key="key">
            <div class="d-flex align-items-center">
              <button
                class="btn btn-link btn-reset text-body px-0 py-0 mt-1 mb-2 w-100 d-flex align-items-center"
                type="button"
                data-toggle="collapse"
                :data-target="`#filter-dep-outer-${index}`"
                aria-expanded="false"
                :aria-controls="`filter-dep-outer-${index}`"
                >
                {{ value.label }}
                <span class="icon icon-navigation_pfeil_unten mt-n2 ml-auto px-0"></span>
              </button>
            </div>
            <div class="collapse" :id="`filter-dep-outer-${index}`">
              <ul class="list-unstyled mt-0" v-if="value.deps && value.deps.length > 0">
                <li class="mb-1" v-for="(depInner, indexInner) in value.deps" :key="depInner.id">
                  <div class="d-flex align-items-center">
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" v-model="dep" :value="depInner.id" :id="`filter-dep-inner-${index}-${indexInner}`" @change="onSubmit">
                      <label class="form-check-label" :for="`filter-dep-inner-${index}-${indexInner}`">
                        {{ depInner.label }}
                      </label>
                    </div>
                    <div class="filter-box-count-number ml-auto">
                      {{ getDepCount(depInner) }}
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </li>
        </ul>

      </div> <!-- /filter-box -->

      <div class="filter-box" v-if="showFormFilter">
        <span class="filter-box-headline">{{ t('vab.filter.participation') }}</span>

        <ul class="list-unstyled mb-0">
          <li class="mb-0" v-for="([key, value], index) in formMap" :key="key">
            <div class="d-flex align-items-center">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" v-model="form" :value="value.id" :id="`filter-participation-${index}`" @change="onSubmit">
                <label class="form-check-label" :for="`filter-participation-${index}`">
                  {{ value.label }}
                </label>
              </div>
              <div class="filter-box-count-number ml-auto">
                {{ getFormCount(value.id) }}
              </div>
            </div>
          </li>
        </ul>

      </div> <!-- /filter-box -->
    </div>
  </aside>

  <main
    class="col-12 content col-xl-9 content"
    id="content"
    role="main"
    >

      <h1>
        <span v-if="pageTitle" class="title" id="labelformodal" v-html="sanitizeHtml(pageTitle)"></span>
        <span v-if="pageSubtitle" class="subtitle" v-html="sanitizeHtml(pageSubtitle)"></span>
      </h1>
      <p v-if="pageDescription" class="abstract" v-html="sanitizeHtml(pageDescription)"></p>

      <div class="area-search">
        <div class="formContainer">
          <form @submit.prevent="onSubmit" action="#" method="get">
              <div class="input-group input-group-lg searchbar searchbar-container mb-3">
                <label for="area-search-query" class="sr-only">{{ t('search.headerViewSearchterm') }}</label>
                <input v-model="queryString" type="search" id="area-search-query" class="search form-control" :placeholder="t('search.headerViewSearchterm')">
                <div class="input-group-append">
                  <button class="btn btn-brand1" type="submit" id="search-bottom-button" :title="t('search.headerViewSearch2')">
                    <span class="icon icon-lupe" aria-hidden="true"></span><span class="sr-only">{{ t('search.headerViewSearch2') }}</span>
                  </button>
                </div>
              </div>
          </form>
          <template v-if="!loading">
            <div v-if="result && result.queryString" id="infoBlock" class="infoBlock">
              <div v-if="(result.numItems || 0) > 0" id="infoBlockFound" class="found searchresult-teaser text-center"><span>{{ t('search.searchresultsAmountFound').replace('%TERM%', result.queryString).replace('%AMOUNT%', (result.numItems || 0).toString()) }}</span></div>
              <div v-else id="infoBlockNotFound" class="notFound searchresult-teaser text-center"><span>{{ t('search.searchresultsNotFound').replace('%TERM%', result.queryString) }}</span></div>
            </div>
            <div v-else-if="result" id="infoBlock" class="infoBlock">
              <div v-if="(result.numItems || 0) > 0" id="infoBlockFound" class="found searchresult-teaser text-center"><span>{{ t('search.searchresultsAmountFoundNoQuerystring').replace('%AMOUNT%', (result.numItems || 0).toString()) }}</span></div>
              <div v-else id="infoBlockNotFound" class="notFound searchresult-teaser text-center"><span>{{ t('search.searchresultsNotFoundNoQuerystring') }}</span></div>
            </div>
            <div v-else class="searchresult-teaser text-center">
              <small>{{ t('search.searchresultsEmptySearchString') }}</small>
            </div>
            <div class="d-xl-none d-print-none searchresult-teaser text-center">
              <a href="#searchfilter" class="searchfilter-toggle" data-toggle="collapse" aria-expanded="false" aria-controls="searchfilter">{{ t('search.searchresultsOpenFilterString') }}</a>
            </div>
          </template>
          <template v-else>
            <div class="searchresult-teaser text-center">&nbsp;</div>
          </template>
        </div>
      </div> <!-- /area-search -->

      <div class="row" v-if="result && (result.numItems || 0) > 0">
        <div class="col-12 d-flex align-items-center justify-content-end flex-column flex-md-row">
          <span>{{ t('search.searchsortlabel') }}:</span>
          <div class="d-flex flex-column flex-sm-row">
            <div class="form-group mb-0 pl-3">
              <label for="sort" class="sr-only">{{ t('search.searchsortlabel') }}</label>
              <select class="custom-select" name="sort" id="sort" v-model="sortType" @change="onSubmitSort">
                <option value="date">
                    {{ t('search.searchsortdate') }}
                </option>
                <option value="relevance">
                    {{ t('search.searchsortrelevance') }}
                </option>
              </select>
            </div>
            <div class="">
              <button type="button" :class="`btn btn-link${sortOrder == 'asc' ? '  text-primary' : ''}`" :aria-pressed="sortOrder == 'asc' ? 'true' : 'false'" @click="changeSortOrder('asc')">
                <span class="icon icon-navigation_pfeil_zurueck mr-1 d-inline-block rotate-90"></span>
                {{ t('search.searchsortasc') }}
              </button>
              <button type="button" :class="`btn btn-link${sortOrder == 'desc' ? '  text-primary' : ''}`" :aria-pressed="sortOrder == 'desc' ? 'true' : 'false'" @click="changeSortOrder('desc')">
                <span class="icon icon-navigation_pfeil_zurueck mr-1 d-inline-block rotate-n90"></span>
                {{ t('search.searchsortdesc') }}
              </button>
            </div>
          </div>
        </div>
      </div> <!-- /row sort -->

      <loading-container :state="state">
        <nav v-if="(result.numItems || 0) > 0" aria-label="Suchergebnis" class="resultContainer search-results-container">
          <ul class="list row list-unstyled overview overview-list overview-searchresult has-pagination">
            <template v-for="(item, index) in (result && result.result && result.result.resultList || [])" v-bind:key="index">
              <Page
                v-if="item['system_s'] === 'website'"
                :item=item
                :highlight="getHighlight(item)"
                :nodeLink="getNodeLink(item)"
                :ancestors="getAncestors(item)"
                :badges="getBadges(item)"
                />
              <Asset
                v-if="item['system_s'] === 'dam'"
                :item=item
                :highlight="getHighlight(item)"
                :nodeLink="getNodeLink(item)"
                :dependants="getDependants(item)"
                :badges="getBadges(item)"
                />
              <Course
                v-if="item['system_s'] === 'courses'"
                :item=item
                :highlight="getHighlight(item)"
                :nodeLink="getNodeLink(item)"
                :ancestors="getAncestors(item)"
                :badges="getBadges(item)"
                :detailUrl="detailUrl"
                />
            </template>
          </ul>
          <div class="loader" aria-hidden="true"></div>
          <div v-if="!isLastPage" class="loadWrapper">
            <loading-container :state="pagingState">
              <button class="loadMore" @click="loadNext">{{ t('search.searchresultsLoadmoreTitle') }}</button>
            </loading-container>
          </div>
        </nav>
      </loading-container>

  </main>
</template>
<script lang="ts">
import { defineComponent } from 'vue'
import { useI18n } from 'vue-i18n'
import {
  SolrAjaxResult,
  FacetField,
  SearchSystem,
  SearchDocType,
  SearchTopic,
  SearchDep,
  SearchForm,
} from '@/models/SolrSearchModels'
import LoadingContainer from './components/structure/LoadingContainer.vue'
import LoadingMixin from './mixins/LoadingMixin'
import axios from "axios";
import Asset from './components/search/Asset.vue'
import Page from './components/search/Page.vue'
import Course from './components/search/Course.vue'
import { sanitizeHtml } from './utils/domUtils'
import { LoadingState } from './utils/loadingUtils';
import { formatDate } from './utils/dateUtils'
import { DateTime } from 'luxon'

export default defineComponent({
  name: 'WidgetSearchVab',
  setup() {
    const { t } = useI18n()
    return { t }
  },
  components: {
    LoadingContainer,
    Page,
    Asset,
    Course
  },
  mixins: [
    LoadingMixin
  ],
  data() {
    return {
      sanitizeHtml: sanitizeHtml,
      result: {} as SolrAjaxResult,
      pagingState: LoadingState.success,
      queryString: this.vueWidgetSearchQueryString,
      type: this.vueWidgetSearchType && this.vueWidgetSearchType.split(',').map(str => str.trim()) || [],
      searchtype: this.vueWidgetSearchSearchtype,
      docType: this.vueWidgetSearchDocType && this.vueWidgetSearchDocType.split(',').map(str => str.trim()) || [],
      topic:this.vueWidgetSearchTopic && this.vueWidgetSearchTopic.split(',').map(str => str.trim()) || [],
      dep:this.vueWidgetSearchDep && this.vueWidgetSearchDep.split(',').map(str => str.trim()) || [],
      form:this.vueWidgetSearchForm && this.vueWidgetSearchForm.split(',').map(str => str.trim()) || [],
      dateFrom: this.vueWidgetSearchDateFrom || '',
      dateTo: this.vueWidgetSearchDateTo || '',
      sortType: this.vueWidgetSearchSortType || 'relevance',
      sortOrder: this.vueWidgetSearchSortOrder || 'desc',
      itemsPerPage: Number(this.vueWidgetSearchItemsperpage) || 10,
      currentPage: Number(this.vueWidgetSearchCurrentPage) || 0,
      systemMap: new Map(Object.entries((JSON.parse(this.vueWidgetSearchSystemMap) || {}))) as Map<string, SearchSystem>,
      docTypeMap: new Map(Object.entries((JSON.parse(this.vueWidgetSearchDocTypeMap) || {}))) as Map<string, SearchDocType>,
      topicMap: new Map(Object.entries((JSON.parse(this.vueWidgetSearchTopicMap) || {}))) as Map<string, SearchTopic>,
      depMap: new Map(Object.entries((JSON.parse(this.vueWidgetSearchDepMap) || {}))) as Map<string, SearchDep>,
      formMap: new Map(Object.entries((JSON.parse(this.vueWidgetSearchFormMap) || {}))) as Map<string, SearchForm>,
      mainClass: this.vueWidgetSearchMainClass || '',
      pageTitle: this.vueWidgetSearchPageTitle || '',
      pageSubtitle: this.vueWidgetSearchPageSubtitle || '',
      pageDescription: this.vueWidgetSearchPageDescription || '',
      showTopicFilter: ((this.vueWidgetSearchShowTopicFilter && (this.vueWidgetSearchShowTopicFilter == 'true')) ? true : false) || false,
      showDocTypeFilter: ((this.vueWidgetSearchShowDocTypeFilter && (this.vueWidgetSearchShowDocTypeFilter == 'true')) ? true : false) || false,
      showDepFilter: ((this.vueWidgetSearchShowDepFilter && (this.vueWidgetSearchShowDepFilter == 'true')) ? true : false) || false,
      showTypeFilter: ((this.vueWidgetSearchShowTypeFilter && (this.vueWidgetSearchShowTypeFilter == 'true')) ? true : false) || false,
      showDaterangeFilter: ((this.vueWidgetSearchShowDaterangeFilter && (this.vueWidgetSearchShowDaterangeFilter == 'true')) ? true : false) || false,
      showFormFilter: ((this.vueWidgetSearchShowFormFilter && (this.vueWidgetSearchShowFormFilter == 'true')) ? true : false) || false,
      detailUrl: this.vueWidgetSearchDetailUrl,
    }
  },
  props: {
    vueWidgetSearchAjaxUrl: {
      type: String,
      default: ''
    },
    vueWidgetSearchType: {
      type: String,
      default: ''
    },
    vueWidgetSearchSearchtype: {
      type: String,
      default: 'global'
    },
    vueWidgetSearchDocType: {
      type: String,
      default: ''
    },
    vueWidgetSearchTopic: {
      type: String,
      default: ''
    },
    vueWidgetSearchDep: {
      type: String,
      default: ''
    },
    vueWidgetSearchForm: {
      type: String,
      default: ''
    },
    vueWidgetSearchDateFrom: {
      type: String,
      default: ''
    },
    vueWidgetSearchDateTo: {
      type: String,
      default: ''
    },
    vueWidgetSearchSortType: {
      type: String,
      default: 'relevance'
    },
    vueWidgetSearchSortOrder: {
      type: String,
      default: 'desc'
    },
    vueWidgetSearchItemsperpage: {
      type: String,
      default: '10'
    },
    vueWidgetSearchCurrentPage: {
      type: String,
      default: '0'
    },
    vueWidgetSearchQueryString: {
      type: String,
      default: ''
    },
    vueWidgetSearchSystemMap: {
      type: String,
      default: '{}'
    },
    vueWidgetSearchDocTypeMap: {
      type: String,
      default: '{}'
    },
    vueWidgetSearchTopicMap: {
      type: String,
      default: '{}'
    },
    vueWidgetSearchDepMap: {
      type: String,
      default: '{}'
    },
    vueWidgetSearchFormMap: {
      type: String,
      default: '{}'
    },
    vueWidgetSearchMainClass: {
      type: String,
      default: ''
    },
    vueWidgetSearchPageTitle: {
      type: String,
      default: ''
    },
    vueWidgetSearchPageSubtitle: {
      type: String,
      default: ''
    },
    vueWidgetSearchPageDescription: {
      type: String,
      default: ''
    },
    vueWidgetSearchShowTopicFilter: {
      type: String,
      default: ''
    },
    vueWidgetSearchShowDocTypeFilter: {
      type: String,
      default: ''
    },
    vueWidgetSearchShowDepFilter: {
      type: String,
      default: ''
    },
    vueWidgetSearchShowTypeFilter: {
      type: String,
      default: ''
    },
    vueWidgetSearchShowDaterangeFilter: {
      type: String,
      default: ''
    },
    vueWidgetSearchShowFormFilter: {
      type: String,
      default: ''
    },
    vueWidgetSearchDetailUrl: {
      type: String,
      default: ''
    },
  },
  created() {
    this.readUrlParams()
    this.search()
  },
  computed: {
    axiosParams() {
        const params = new URLSearchParams();
        params.append('currentPage', this.currentPage.toString());
        params.append('queryString', this.queryString);

        if(this.searchtype=="courses"){
          params.append('type', "courses");
        } else {
          this.type.forEach( (element) => {
            const system = this.systemMap.get(element)
            if (system && system.system) {
              system.system.forEach( (s) => {
                params.append('type', s);
              })
            }
          });
        }

        this.docType.forEach( (element) => {
          const docType = this.docTypeMap.get(element)
          if (docType && docType.extension) {
            docType.extension.forEach( (e) => {
              params.append('docType', e);
            })
          }
        });

        this.topic.forEach((element) => {
            params.append('topic', element);
        });

        this.form.forEach((element) => {
            params.append('form', element);
        });

        this.dep.forEach((element) => {
            params.append('dep', element);
        });

        if (this.dateFrom) {
          params.append('dateFrom', formatDate(this.dateFrom, 'DD.MM.YYYY'));
        }
        if (this.dateTo) {
          params.append('dateTo', formatDate(this.dateTo, 'DD.MM.YYYY'));
        }

        params.append('sortType', this.sortType);
        params.append('sortOrder', this.sortOrder);
        params.append('itemsPerPage', String(this.itemsPerPage));

        return params;
    },
    numPages(): number {
      return (this.result.numPages) || 0;
    },
    numItems(): number {
      return (this.result.numItems) || 0;
    },
    firstItem(): number {
      return 1 + (this.result.currentPage || 0) * (this.result.itemsPerPage || 10)
    },
    lastItem(): number {
      const itemsPerPage = (this.result.itemsPerPage || 0)
      const numPages = this.numPages
      const currentPage = (this.result.currentPage || 0)
      const numItems = this.numItems
      if (numPages === currentPage + 1) {
        return numItems % itemsPerPage;
      } else {
        return itemsPerPage;
      }
    },
    isLastPage(): boolean {
      const numPages = this.numPages
      const currentPage = (this.result.currentPage || 0)
      return (currentPage + 1) >= numPages
    },
    resultString(): string {
      if (this.result) {
        if(this.result.numItems == 1){
          switch(this.searchtype){
            default:
              return `${this.result.numItems} Suchtreffer gefunden`;
          }
        }
        if(this.result.queryString){

          switch(this.searchtype){
            default:
              return `${this.result.numItems || 0} Suchtreffer für "${this.result.queryString || ''}" gefunden`
          }
        } else {
          switch(this.searchtype){
            default:
              return `${this.result.numItems || 0} Suchtreffer gefunden`;
          }
        }
      }
      return ''
    },
    loading(): boolean {
      return this.state === LoadingState.loading
    }
  },
  methods: {
    setItemsPerPage(items : number) {
        this.itemsPerPage = items;
        this.onSubmit();
    },
    search() {
      this.state = LoadingState.loading;
      axios.get(this.vueWidgetSearchAjaxUrl, {
        params: this.axiosParams
      })
      .then(res => {
        this.result = res.data;
        if (this.result && this.result.queryString) {
          this.queryString = this.result.queryString;
        }
        if (this.result) {
          this.result.numItemsShown = (this.result.itemsPerPage || 0) * ((this.result.currentPage || 0) + 1);
        }
        this.handleSuccess();
        this.pushQueryParams();
      })
      .catch(this.handleError)
    },
    pushQueryParams() {
      history.pushState({}, '', decodeURIComponent(`${window.location.pathname}?${this.axiosParams}`))
    },
    readUrlParams() {
      const searchParams = new URLSearchParams(window.location.search);

      searchParams.getAll('type').forEach( (element) => {
        this.systemMap.forEach( (system) => {
          if ((system.system || []).includes(element) && system.id && !this.type.includes(system.id)) {
            this.type.push(system.id);
          }
        })
      });
      searchParams.getAll('docType').forEach( (element) => {
        this.docTypeMap.forEach( (docType) => {
          if ((docType.extension || []).includes(element) && docType.id && !this.docType.includes(docType.id)) {
            this.docType.push(docType.id);
          }
        })
      });
      searchParams.getAll('topic').forEach( (element) => {
        this.topicMap.forEach((topic) => {
          if (topic.id && (topic.id == element) && !this.topic.includes(topic.id) ){
            this.topic.push(topic.id);
          }
        })
      });
      searchParams.getAll('form').forEach( (element) => {
        this.form.push(element);
      });
      searchParams.getAll('dep').forEach( (element) => {
        this.depMap.forEach((outerDep) => {
          if (outerDep.deps) {
            outerDep.deps.forEach((dep) => {
              if (dep.id && (dep.id == element) && !this.topic.includes(dep.id) ){
                this.dep.push(dep.id);
              }
            })
          }
        })
      });
      if (searchParams.get('dateFrom')) {
        this.dateFrom = DateTime.fromFormat(searchParams.get('dateFrom') || '', "dd.MM.yyyy", { locale: 'de-AT' }).toFormat("yyyy-MM-dd") || ''
      }
      if (searchParams.get('dateTo')) {
        this.dateTo = DateTime.fromFormat(searchParams.get('dateTo') || '', "dd.MM.yyyy", { locale: 'de-AT' }).toFormat("yyyy-MM-dd") || ''
      }
      this.queryString = searchParams.get('q') || searchParams.get('queryString') || this.queryString || ''
      this.sortOrder = searchParams.get('sortOrder') || this.sortOrder || 'desc'
      this.sortType = searchParams.get('sortType') || this.sortType || 'relevance'
    },
    changeSortOrder(sortOrder: string) {
      switch(sortOrder) {
        case "asc":
          this.sortOrder = "asc";
          break;
        case "desc":
          this.sortOrder = "desc";
          break;
      }
      this.onSubmitSort();
    },
    onSubmitSort() {
      switch (this.sortType) {
        case "date":
          //this.sortOrder = "desc";
          break;
        case "relevance":
          //this.sortOrder = "asc";
          break;
        default:
          //this.sortOrder = "desc";
      }
      this.onSubmit();
    },
    onSubmit() {
      this.currentPage = 0;
      this.search();
    },
    resetFilters() {
      if(this.searchtype == 'global') {
        this.type = this.vueWidgetSearchType && this.vueWidgetSearchType.split(',').map(str => str.trim()) || []
      }
      this.docType = this.vueWidgetSearchDocType && this.vueWidgetSearchDocType.split(',').map(str => str.trim()) || []
      this.topic = this.vueWidgetSearchTopic && this.vueWidgetSearchTopic.split(',').map(str => str.trim()) || []
      this.dep = this.vueWidgetSearchDep && this.vueWidgetSearchDep.split(',').map(str => str.trim()) || []
      this.form = this.vueWidgetSearchForm && this.vueWidgetSearchForm.split(',').map(str => str.trim()) || []
      this.dateFrom =  this.vueWidgetSearchDateFrom || ''
      this.dateTo =  this.vueWidgetSearchDateTo || ''
      this.sortType =  this.vueWidgetSearchSortType || 'relevance'
      this.sortOrder =  this.vueWidgetSearchSortOrder || 'desc'

      this.onSubmit();
    },
    loadNext() {
      this.pagingState = LoadingState.loading;
      this.currentPage += 1;
      axios.get(this.vueWidgetSearchAjaxUrl, {
        params: this.axiosParams
      })
      .then(res => {
        if (this.result && this.result.result && this.result.result.resultList && this.result.result.resultList.length > 0 ) {
          this.result.result.resultList = this.result.result.resultList.concat(res.data.result.resultList);
          this.result.result.highlighting = Object.assign(this.result.result.highlighting || {} , res.data.result.highlighting || {});
          this.result.nodeLinks = (this.result.nodeLinks || []).concat(res.data.nodeLinks);
          this.result.dependants = Object.assign(this.result.dependants || {} , res.data.dependants || {});
          this.result.currentPage = this.currentPage;
          this.result.numItemsShown = (this.result.numItemsShown || 0) + this.lastItem;
        } else {
          this.result = res.data;
        }
        this.pagingState = LoadingState.success;
      })
      .catch(() => {
        this.pagingState = LoadingState.error
      })
    },
    setSortType(sortType: string) {
      this.sortType = sortType;
      this.onSubmit();
    },
    setSortOrder(sortOrder: string) {
      this.sortOrder = sortOrder;
      this.onSubmit();
    },
    toggleSortOrder() {
      this.sortOrder = (this.sortOrder == "asc") ? "desc" : "asc";
      this.onSubmit();
    },
    setCurrentPage(newCurrentPage: number) {
      if (newCurrentPage >= 0 && newCurrentPage+1 <= this.numPages) {
        this.currentPage = newCurrentPage;
        this.search();
      }
    },
    facetField(facetFieldName: string): FacetField {
      if (this.result && this.result.result && this.result.result.facetFields) {
        const ff = this.result.result.facetFields.find(x => x._name === facetFieldName);
        if (ff) {
          return ff
        }
      }
      return {};
    },
    getSystemCount(system: any) {
      const facetField = this.facetField('system')
      if (facetField && facetField._values && system && system.system) {
        return `(${facetField._values.filter(field => system.system.includes(field._name)).map(field => field._count).reduce((x, y) => (x || 0) + (y || 0), 0)})` || '';
      }
    },
    getDocTypeCount(docType: any) {
      const facetField = this.facetField('fileextension_s')
      if (facetField && facetField._values && docType && docType.extension) {
        return `(${facetField._values.filter(field => docType.extension.includes(field._name)).map(field => field._count).reduce((x, y) => (x || 0) + (y || 0), 0)})` || '';
      }
    },
    getTopicCount(topic: any) {
      const facetField = this.facetField("topic_s")
      if (facetField && facetField._values && topic && topic.id) {
        return `(${facetField._values.filter(field => topic.id == field._name).map(field => field._count).reduce((x, y) => (x || 0) + (y || 0), 0)})` || '';
      }
    },
    getDepCount(dep: any) {
      const facetField = this.facetField("course_dep_ss")
      if (facetField && facetField._values && dep && dep.id) {
        return `(${facetField._values.filter(field => dep.id == field._name).map(field => field._count).reduce((x, y) => (x || 0) + (y || 0), 0)})` || '';
      }
    },
    getFormCount(form: string) {
      const facetField = this.facetField("course_formtype_s")
      if (facetField && facetField._values && form) {
        return `(${facetField._values.filter(field => form == field._name).map(field => field._count).reduce((x, y) => (x || 0) + (y || 0), 0)})` || '';
      }
    },
    getHighlight(item: any) {
      if (item && item['id']) {
        const id = item['id']
        if (this.result && this.result.result && this.result.result.highlighting && this.result.result.highlighting[id]) {
          const highlighting = this.result.result.highlighting[id];
          if (highlighting && highlighting['text_exact']) {
            const highlights = highlighting['text_exact']
            if (highlights && highlights[0]) {
              return sanitizeHtml(highlights[0])
            }
          } else if (highlighting && highlighting['text_hl']) {
            const highlights = highlighting['text_hl']
            if (highlights && highlights[0]) {
              return sanitizeHtml(highlights[0])
            }
          } else if (highlighting && highlighting['content']) {
            const highlights = highlighting['content']
            if (highlights && highlights[0]) {
              return sanitizeHtml(highlights[0])
            }
          } else if (highlighting && highlighting['text_ngram']) {
            const highlights = highlighting['text_ngram']
            if (highlights && highlights[0]) {
              return sanitizeHtml(highlights[0])
            }
          }
        }
      }
      return ''
    },
    getNodeLink(item: any) {
      if (item && item['id']) {
        const id = item['id']
        if (this.result && this.result.nodeLinks) {
          const nodeLink = this.result.nodeLinks.find(x => x.id === id)
          return nodeLink || {}
        }

      }
      return {}
    },
    getAncestors(item: any) {
      if (item && item['id']) {
        const id = item['id']
        if (this.result && this.result.nodeLinks) {
          const nodeLink = this.result.nodeLinks.find(x => x.id === id)
          return (nodeLink && nodeLink.ancestors) || []
        }

      }
      return []
    },
    getDependants(item: any) {
      if (item && item['id']) {
        const id = item['id']
        if (this.result && this.result.dependants) {
          const dependantMap = new Map(Object.entries(this.result.dependants)).get(id)
          return dependantMap || []
        }

      }
      return []
    },
    getBadges(item: any) {
      let badges = [] as string[]
      // add topic badges
      if (item && item['path'] && item['path'][0]) {
        const itemPath = item['path'][0];
        this.topicMap.forEach( (topic) => {
          if (topic.path && itemPath.includes(topic.path)) {
            if (topic && topic.label) {
              badges.push(topic.label)
            }
          }
        })
      }
      // add docType badges
      if (item && item['fileextension_t'] && item['fileextension_t'][0]) {
        const ext = item['fileextension_t'][0];
        this.docTypeMap.forEach( (docType) => {
          if (docType.extension && (docType.extension.includes(ext.toLowerCase()))) {
            if (docType && docType.label) {
              badges.push(docType.label)
            }
          }
        })
      }
      return badges
    },
  }
})
</script>
<style scoped>
.rotate-90 {
  transform: rotate(90deg);
}
.rotate-n90 {
  transform: rotate(-90deg);
}
</style>
